import {
  useTranslate, TextField, useRecordContext, TextFieldProps,
} from 'react-admin';
import get from 'lodash/get';

export const TimeGranularityField = ({ source, ...rest }: TextFieldProps & { source: string }) => {

  const translate = useTranslate();
  const record = useRecordContext();

  const type = get(record, `${source}.type`);
  const granularityType = type ? translate(`resources.report-triggers.text.granularity_types.${type}`).toLowerCase() : translate('general.text.none');
  const granularityValue = get(record, `${source}.value`) ?? 0;

  return <TextField source="value" record={{ value: `${granularityValue} ${granularityType} ` }} {...rest} />;

};
